import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ActivateAccount } from './activate-account.model';
import * as ActivateAccountActions from './activate-account.actions';

export const activateAccountsFeatureKey = 'activateAccounts';

export interface State extends EntityState<ActivateAccount> {
  // additional entities state properties
}

export const adapter: EntityAdapter<ActivateAccount> = createEntityAdapter<ActivateAccount>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(ActivateAccountActions.addActivateAccount,
    (state, action) => adapter.addOne(action.activateAccount, state)
  ),
  on(ActivateAccountActions.upsertActivateAccount,
    (state, action) => adapter.upsertOne(action.activateAccount, state)
  ),
  on(ActivateAccountActions.addActivateAccounts,
    (state, action) => adapter.addMany(action.activateAccounts, state)
  ),
  on(ActivateAccountActions.upsertActivateAccounts,
    (state, action) => adapter.upsertMany(action.activateAccounts, state)
  ),
  on(ActivateAccountActions.updateActivateAccount,
    (state, action) => adapter.updateOne(action.activateAccount, state)
  ),
  on(ActivateAccountActions.updateActivateAccounts,
    (state, action) => adapter.updateMany(action.activateAccounts, state)
  ),
  on(ActivateAccountActions.deleteActivateAccount,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(ActivateAccountActions.deleteActivateAccounts,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(ActivateAccountActions.loadActivateAccounts,
    (state, action) => adapter.setAll(action.activateAccounts, state)
  ),
  on(ActivateAccountActions.clearActivateAccounts,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
